import React, { useState } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import "./Navbar.scss";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen);

  const scrollToSection = (sectionId) => {
    document.getElementById(sectionId).scrollIntoView({ behavior: "smooth" });
    setMenuOpen(false); 
  };

  return (
    <nav className="navbar">
      <div className="navbar__logo"><b>English</b>Enclave</div>
      <div className={`navbar__menu ${menuOpen ? "active" : ""}`}>
        <div className="navbar__item" onClick={() => scrollToSection("home")}>
          Home
        </div>
        <div className="navbar__item" onClick={() => scrollToSection("about")}>
          About
        </div>
        <div className="navbar__item" onClick={() => scrollToSection("services")}>
          Services
        </div>
        <div className="navbar__item" onClick={() => scrollToSection("contact")}>
          Contact
        </div>
      </div>
      <div className="navbar__hamburger" onClick={toggleMenu}>
        {menuOpen ? <FaTimes /> : <FaBars />}
      </div>
    </nav>
  );
};

export default Navbar;
